import { render, staticRenderFns } from "./DashboardInput.vue?vue&type=template&id=6c3477ee&scoped=true&"
import script from "./DashboardInput.vue?vue&type=script&lang=js&"
export * from "./DashboardInput.vue?vue&type=script&lang=js&"
import style0 from "./DashboardInput.vue?vue&type=style&index=0&id=6c3477ee&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c3477ee",
  null
  
)

export default component.exports